import 'core-js/client/shim';

import 'es7-reflect-metadata/dist/browser';

import 'zone.js/dist/zone';
import 'zone.js/dist/long-stack-trace-zone';

import '@angular/common';
import '@angular/compiler';
import '@angular/core';
import '@angular/forms';
import '@angular/http';
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/router';
import '@angular/upgrade';

import 'rxjs';



// WEBPACK FOOTER //
// ./resources/assets/typescript/vendor.ts